import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Deliverable } from './components/Deliverable';
import { Pricing } from './components/Pricing';
import { Security } from './components/Security';
import { Timeline } from './components/Timeline';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-amber-100 selection:text-amber-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <Deliverable data-id="element-5" />
        <Pricing data-id="element-6" />
        <Security data-id="element-7" />
        <Timeline data-id="element-8" />
        <CTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}